import { TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { useGetUnknownQueryKey } from "../../../hooks/useGetUnknownQueryKey";
import { UnknownSecurities } from "../../../Type";

export default function Ticker({ tickerSymbol, securityId }: UnknownSecurities) {
	const client = useQueryClient();
	const key = useGetUnknownQueryKey();

	const handleOnChangeTicker = ({ target }: any) => {
		client.setQueryData(key, (data?: UnknownSecurities[]) => {
			return (data || []).map((i) =>
				i.securityId === securityId ? { ...i, tickerSymbol: target.value } : i
			);
		});
	};

	return (
		<TextField
			value={tickerSymbol ?? ""}
			size='small'
			sx={{ width: 80 }}
			placeholder='Ticker'
			onChange={handleOnChangeTicker}
		/>
	);
}
